// extracted by mini-css-extract-plugin
module.exports = {"divider":"AttachmentAddPopup_divider__2oZli","menu":"AttachmentAddPopup_menu__36l9A","menuItem":"AttachmentAddPopup_menuItem__bBBSP","tip":"AttachmentAddPopup_tip__lMhTM"};